const selectors = {
  complementaryProducts: 'complementary-products',
  quickAddProduct: 'quick-add-product',
};

const attributes = {
  url: 'data-url',
  slider: 'data-slider',
};

class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      if (this.hasAttribute(attributes.url) && this.getAttribute(attributes.url) !== '') {
        fetch(this.getAttribute(attributes.url))
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(selectors.complementaryProducts);

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // After content is loaded, initialize slider if needed
              if (this.hasAttribute(attributes.slider)) {
                this.dispatchEvent(
                  new CustomEvent('theme:complementary:loaded', {
                    bubbles: true,
                    detail: {
                      container: this,
                    },
                  })
                );
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', ComplementaryProducts);
}
